"use strict";
/*
* Copyright 2013 ZXing authors
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*      http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var Token = /** @class */ (function () {
    function Token(previous) {
        this.previous = previous;
    }
    Token.prototype.getPrevious = function () {
        return this.previous;
    };
    return Token;
}());
exports.default = Token;



//////////////////
// WEBPACK FOOTER
// ./~/@zxing/library/cjs/core/aztec/encoder/Token.js
// module id = 647
// module chunks = 4